export interface OrderDTO {
    orderId: string;
    marketplaceOrderId: string;
    marketplace: string;
    creationDate: string;
    lastUpdatedDate: string;
    status: string;
    customer: CustomerDTO;
    billingAddress: AddressDTO;
    shippingAddress: AddressDTO;
    shippingService?: string;
    items: OrderItemDTO[];
    mexalDocumentId?: string;
    hasQuantityWarning: boolean;
    
    // Dati fatturazione
    invoiceRequested: boolean;
    sdiCode?: string;
    pecEmail?: string;
    isCompany: boolean;
    companyType?: string;
}

export interface CustomerDTO {
    customerId: string;
    firstName: string;
    lastName: string;
    email?: string;
    phone?: string;
    fiscalCode?: string;
    vatNumber?: string;
    civility?: string;
    locale?: string;
}

export interface AddressDTO {
    firstName?: string;
    lastName?: string;
    street: string;
    street2?: string;
    city: string;
    zipCode: string;
    state?: string;
    country: string;
    company?: string;
    phone?: string;
}

export interface OrderItemDTO {
    sku: string;
    marketplaceSku: string;
    productName: string;
    quantity: number;
    availableQuantity: number;
    price: number;
    currency: string;
}

export enum OrderStatus {
    STAGING = "STAGING",
    WAITING_ACCEPTANCE = "WAITING_ACCEPTANCE",
    WAITING = "WAITING",
    WAITING_DEBIT = "WAITING_DEBIT",
    WAITING_DEBIT_PAYMENT = "WAITING_DEBIT_PAYMENT",
    SHIPPING = "SHIPPING",
    SHIPPED = "SHIPPED",
    RECEIVED = "RECEIVED",
    CLOSED = "CLOSED",
    REFUSED = "REFUSED",
    CANCELED = "CANCELED",
    REFUNDED = "REFUNDED",
    INCIDENT_OPEN = "INCIDENT_OPEN",
    UNKNOWN = "UNKNOWN"
}

export interface OrderFilterDTO {
    marketplaces?: string[];
    statuses?: string[];
    startDate?: string;
    endDate?: string;
    search?: string;
}
